import Feedback from "./pages/client/Feedback";


export const RoutesCustom = {
  // Public Pages
  Signin: { url: "/" },
  NotFound: { url: "/404" },

  // Admin Dashboard
  AdminDashboardOverview: { url: "/admin/dashboard-overview" },
  AdminSignup: { url: "/admin/create-user" },
  ClaimsAdmin: { url: "/admin/all-claims" },
  Clients: { url: "/admin/all-clients" },
  Cancellation: { url: "/admin/cancellation" },
  DebtCollection: { url: "/admin/debt-collection" },
  Completed: { url: "/admin/completed" },
  CourtDunningProcedure: { url: "/admin/court-dunning-procedure" },
  Foreclosures: { url: "/admin/foreclosures" },
  Installmentpayment: { url: "/admin/installment-payment" },
  Resubmissions: { url: "/admin/resubmissions" },
  Paid: { url: "/admin/paid" },
  Messages2: { url: "/admin/messages" },
  FeedbackAdmin: { url: "/admin/feedback" },

  // Client Dashboard
  ClientDashboardOverview: { url: "/client/dashboard-overview" },
  ClientSignup: { url: "/client/create-user" },
  Claims: { url: "/client/your-claims" },
  Mandate: { url: "/client/your-mandate" },
  Profile: { url: "/client/your-profile" },
  UploadClaim: { url: "/client/upload-claim" },
  ResetPassword: { url: "/reset-password/:token" },
  Completed2: { url: "/client/completed" },
  Messages: { url: "/client/messages" },
  Lexware: { url: "/client/connect/lex-ware" },
  ExcelUpload: { url: "/client/connect/excel-upload" },
  FastBill: { url: "/client/connect/fast-bill" },
  Xentral: { url: "/client/connect/xentral" },
  Sevdesk: { url: "/client/connect/sev-desk" },
  SageActive: { url: "/client/connect/sage-active" },
  FeedbackClient: { url: "/client/feedback" },

};

